<template>
    <div class="search__content">
        <div class="search__input">
            <div class="form__group">
                <label>
                    <div class="form__label">{{ trans('form-label') }}</div>
                    <div class="form__input">
                        <input type="text" 
                               name="search" 
                               autocomplete="off"
                               v-model="term"
                               v-on:keyup.enter="submit"
                               ref="search">
                    </div>
                </label>
            </div>
        </div>

        <div class="search__results" data-product-list="Search" data-product-list-id="search_products">
            <div class="search__results-items horizontal-products"
                 v-if="!empty && searched"
                 v-bind:class="{ 'm-b-24': results && (loading || hasMore) }">
            </div>
        </div>

        <div class="search__view-more" v-if="searched && !empty && !loading">
                <a v-bind:href="searchLink" class="btn btn--primary">{{ trans('view-all') }}</a>
            </div>

            <div class="search__hint" v-if="empty">
                {{ trans('no-results') }}
            </div>

            <div class="search__hint" v-if="loading || hasMore">
                {{ trans('loading') }}
            </div>

             <div class="search__hint" v-if="!searched">
                <span class="pink">*</span>{{ trans('search-hint') }}
            </div>
    </div>
</template>

<script>
    export default {
        props: [
            "url",
            "translations"
        ],

        request: null,
        termTimer: null,
        itemsPerPage: 12,

        data() {
            return {
                term: '',
                results: false,
                loading: false,
                hasResults: false,
                hasMore: false,
                currentPage: 1,
            }
        },

        computed: {
          empty() {
            return this.searched && !this.results && !this.loading;
          },

          searched() {
            return this.term ? this.term.length >= 2 : false;
          },

          busy() {
            return this.request || !this.hasMore;
          },

          searchLink() {
            var url = this.url;
            var term = this.term;

            return this.url + "?term=" + term;
          }
        },

        methods: {
            search: function (page) { 
                if(!page) {
                    page = 1;
                }

                if(this.request && page == 1) {
                    this.request.abort();
                }

                this.loading = true;
                this.currentPage = page;

                var term = this.term;

                this.request = $.ajax({
                    method: "POST",
                    url: this.url,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: {
                        term: term,
                        page: page,
                        component: true
                    },
                    cache: false,
                    success: (response) => {
                        if(!response) {
                            if (page == 1) {
                                this.results = false;
                                this.loading = false;
                            } 
                            else {
                                this.loading = false;
                            }

                            this.hasMore = false;
                        }

                        else {
                            this.results = true;

                            this.$nextTick(() => {
                                if (page == 1) {
                                    this.$el.querySelector(".search__results-items").innerHTML = response;
                                }

                                else {
                                    this.$el.querySelector(".search__results-items").innerHTML += response;
                                }

                                if (jQuery(response).filter(".js-product-item").length < 10) {
                                    this.loading = false;
                                    this.hasMore = false;
                                }

                                else {
                                    this.hasMore = true;
                                }

                                if (window.ECMT) {
                                    window.ECMT.trackImpressions(".search");
                                    window.ECMT.trackSearch(term);
                                }
                            });
                        }
                    },

                }).done(() => {
                    this.request = null;
                });
            },

            submit: function() {
                window.location = this.searchLink;
            },

            loadMore: function() {
                if (this.busy) {
                    return;
                }

                this.search(this.currentPage + 1);
            },

            setFocus: function () { 
                this.$refs.search.focus();

            },

            trans(key) {
                var translations = JSON.parse(this.translations);

                return translations[key];
            },
        },

        watch: {
            term(newValue) {
                clearTimeout(this.termTimer);

                if (newValue && newValue.length >= 2) {
                    this.loading = true;

                    this.termTimer = setTimeout(() => {
                        this.search();
                    }, 200);
                }

                else {
                    this.loading = false;
                    this.results = false;
                    this.hasMore = false;
                    this.currentPage = 1;

                    if (this.request) {
                        this.request.abort();
                        this.request = null;
                    }
                }
            }
        },

        mounted() {
            this.setFocus();
        }

    }
</script>
